import React from 'react'
import { Formik, Form } from 'formik'

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import PhoneIcon from '@material-ui/icons/Phone'
import Button from '@material-ui/core/Button'
import TextField from '../../form/PhoneField'

const PhoneNumberInput = ({ classes, onSubmit }) => {
  return (
    <Formik onSubmit={onSubmit}>
      {({ dirty, isSubmitting }) => (
        <Form>
          <Grid
            container
            className={classes.wrapper}
            justify="center"
            alignItems="center">
            <Grid item md={3}>
              <Typography variant="display4" gutterBottom>
                Apólice
              </Typography>
              <Typography variant="headline" gutterBottom>
                Sua Apólice Mobile
              </Typography>
              <TextField
                fullWidth
                name="phoneNumber"
                type="phone"
                placeholder="(##) #####-####"
                helperText="informe o seu número de telefone"
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon />
                    </InputAdornment>
                  )
                }}
              />
              <div id="recaptcha-container" />
              <Button
                fullWidth
                variant="outlined"
                size="large"
                color="primary"
                type="submit"
                className={classes.button}
                disabled={!dirty || isSubmitting}>
                {!isSubmitting ? 'ENTRAR' : 'Enviando código ...'}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

const styles = theme => {
  // console.log(theme)
  return {
    wrapper: {
      height: '100vh',
      width: '100vw',
      backgroundColor: theme.palette.secondary.main
    },
    button: {
      marginTop: 50
    }
  }
}

export default withStyles(styles)(PhoneNumberInput)
